// Reglas de interacción del check-in en "Próximos escaneos".
//
// Medido desde el momento en que el partner intenta la acción:
//   - faltan más de 30 minutos  -> bloqueado, el botón se deshabilita
//   - faltan entre 15 y 30      -> se pide confirmación antes de continuar
//   - faltan menos de 15        -> se realiza sin preguntar
//
// Un escaneo cuya hora ya pasó da una diferencia negativa, así que cae en
// ALLOWED, que es lo correcto: lo que se quiere evitar es el check-in
// demasiado anticipado, no el tardío.

export const CHECK_IN_WINDOW = {
  BLOCKED: 'blocked',
  CONFIRM: 'confirm',
  ALLOWED: 'allowed',
};

const CONFIRM_FROM_MINUTES = 15;
const BLOCK_AFTER_MINUTES = 30;

export const getCheckInWindow = (scheduleDate, now = new Date()) => {
  // A propósito no se usa `differenceInMinutes` de date-fns: trunca hacia cero,
  // así que 30 minutos con 30 segundos devolvería 30 y caería en CONFIRM,
  // cuando la regla dice que más de 30 minutos se bloquea. Dividiendo
  // milisegundos la frontera queda exacta.
  const minutes = (new Date(scheduleDate).getTime() - now.getTime()) / 60000;

  // Una fecha inválida da NaN y falla ambas comparaciones, así que termina en
  // ALLOWED: un dato corrupto no debe dejar al partner sin poder trabajar.
  if (minutes > BLOCK_AFTER_MINUTES) {
    return CHECK_IN_WINDOW.BLOCKED;
  }
  if (minutes >= CONFIRM_FROM_MINUTES) {
    return CHECK_IN_WINDOW.CONFIRM;
  }
  return CHECK_IN_WINDOW.ALLOWED;
};
